import React from "react"

import { Grid } from "@material-ui/core"
import { Skeleton } from "@material-ui/lab"

const UpsellQuantityDialogSkeleton = () => {
	return (
		<Grid
			container
			style={{
				height: "100%"
			}}
		>
			<Grid
				item
				xs={8}
			>
				<Grid
					container
					direction="column"
					style={{
						height: "100%",
						padding: "8px 24px"
					}}
				>
					<Grid
						item
					>
						<Grid
							container
							direction="column"
						>
							<Grid
								item
							>
								<Skeleton
									variant="text"
									height={50}
									width="90%"
								/>
							</Grid>
						</Grid>
					</Grid>
					<Grid
						item
					>
						<Grid
							container
							direction="column"
							spacing={3}
						>
							<Grid
								item
							>
								<Skeleton
									variant="text"
									height={100}
									width="95%"
								/>
							</Grid>

							<Grid
								item
							>
								<Grid
									container
									spacing={2}
								>
									{Array.from(new Array(4)).map((_, index) => (
										<Grid
											item
											key={index}
											xs={12}
										>
											<Grid
												container
												alignItems="center"
												spacing={1}
											>
												<Grid
													item
												>
													<Skeleton
														variant="circle"
														width={24}
														height={24}
													/>
												</Grid>
												<Grid
													item
													xs
												>
													<Skeleton
														variant="text"
														height={24}
														width="80%"
													/>
												</Grid>
											</Grid>
										</Grid>
									))}
								</Grid>
							</Grid>

							<Grid
								item
							>
								<Grid
									container
									direction="column"
									spacing={2}
								>
									<Grid
										item
									>
										<Skeleton
											variant="text"
											height={30}
											width="60%"
										/>
									</Grid>
									<Grid
										item
									>
										<Skeleton
											variant="rect"
											height={180}
											width="70%"
										/>
									</Grid>
								</Grid>
							</Grid>

							<Grid
								item
							>
								<Grid
									container
									spacing={3}
								>
									<Grid
										item
										xs={12}
									>
										<Grid
											container
											justifyContent="flex-start"
										>
											<Grid
												item
												xs={10}
											>
												<Skeleton
													variant="rect"
													height={50}
													width="100%"
												/>
											</Grid>
											<Grid
												item
												xs={10}
											>
												<Skeleton
													variant="text"
													height={40}
													width="100%"
												/>
											</Grid>
										</Grid>
									</Grid>
									<Grid
										item
										xs={10}
									>
										<Grid
											container
											style={{
												justifyContent: "center"
											}}
										>
											<Skeleton
												variant="rect"
												height={25}
												width="100%"
											/>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
			<Grid
				item
				xs={4}
			>
				<Skeleton
					variant="rect"
					height="100%"
					width="100%"
				/>
			</Grid>
		</Grid>
	)
}

export default UpsellQuantityDialogSkeleton
